export const ANNOUNCEMENT_REPEAT_OPTIONS = [
  { value: 'none', label: 'Does not repeat' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly (every 3 months)' },
  { value: 'semiannual', label: 'Bi-annual (every 6 months)' },
  { value: 'yearly', label: 'Yearly' }
];

export function announcementRepeatLabel(repeat) {
  if (!repeat || repeat === 'none') return '';
  return ANNOUNCEMENT_REPEAT_OPTIONS.find((option) => option.value === repeat)?.label || '';
}
